module.exports = __webpack_public_path__ + "static/media/vin_door.cc54aeee.jpg";